import { render, staticRenderFns } from "./DictAdd.vue?vue&type=template&id=37e66722"
import script from "./DictAdd.vue?vue&type=script&lang=js"
export * from "./DictAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports